import { jsx as _jsx } from "react/jsx-runtime";
import Link from "@material-ui/core/Link";
const MailtoLink = ({ rowData, loadedData, children, subject, ...props }) => {
    const subjectContent = typeof subject === "function" ? subject(rowData, loadedData) : subject;
    return children ? (_jsx(Link, { ...props, href: `mailto: ${children}${subjectContent && "&subject="}${subjectContent}`, underline: "hover", children: children })) : null;
};
export default MailtoLink;
//# sourceMappingURL=MailtoLink.js.map